import React, { useEffect, useState } from 'react';

import AdviceSection from '../common/AdviceSection';
import SelectFilters from '../common/select-filters/SelectFilters';
import Cards from '../common/cards/Cards';
import Pagination from '../common/pagination/Pagination';
import Methodology from '../common/Methodology';

import { getOSHCountries, getOSHData } from '../../api/index';

const EUChallengesResponse = props => {

	const [countries, setCountries] = useState([]);
	const [pageData, setPageData] = useState([]);
	const [pageOfItems, setPageOfItems] = useState([]);
	const [isFetching, setIsFetching] = useState(false);
	const [filters, setFilters] = useState({
		countries: [],
		checks: [],
		searchBar: ''
	})

	const handleCallbackCountry = (countryCallback) => {
		const countryCode = filters.countries.find((country) => country.code == countryCallback.code)
		if (countryCallback.code != countryCode?.code) {
			setFilters({ ...filters, countries: [...filters.countries, countryCallback ] } );
		} else {
			const index = filters.countries.findIndex((country) => country.code == countryCallback.code);
			let newCountryFilters = filters.countries;
			newCountryFilters.splice(index, 1);
			setFilters( {...filters, countries: newCountryFilters } );
		}
	}
	
	const handleCallbackCategory = (categoryCallback) => {
		const checkFilter = filters.checks.find((data) => data.id == categoryCallback.id);
		if (!checkFilter) 
		{
			setFilters( {...filters, checks: [...filters.checks, { ...categoryCallback, check: true } ] } );
		} 
		else 
		{
			const index = filters.checks.findIndex((data) => data.id == categoryCallback.id);
			let newArray = filters.checks;
			newArray.splice(index, 1);
			setFilters( { ...filters, checks: newArray } );
		}
	}

	// Handles callback for the search bar on filters component
	const handleCallbackSearch = (searchCallback) => {
		setFilters( { ...filters, searchBar: searchCallback } );
	}

	//when country is selected
	const onSelectCountryTag = (countryCode) => {
		return () => {
			const countryIndex = filters.countries.findIndex((country) => country.code == countryCode);
			let newArray = filters.countries;
			newArray.splice(countryIndex, 1);
			setFilters( { ...filters, countries: newArray } );
		}
	}

	//whe category is selected
	const onSelectInstitutionTag = (institutionId) => {
		return () => {
			const institutionIndex = filters.checks.findIndex((institution) => institution.id == institutionId);
			let newArray = filters.checks;
			newArray.splice(institutionIndex, 1);
			setFilters( { ...filters, checks: newArray } )
		}
	}

	// Handles change of page when clicked on the next or prev
	const onChangePage = (pageOfItems) => {
		setPageOfItems(pageOfItems);
	}

	const fetchData = (fetchCountries) => {
		setIsFetching(true);
		try
		{
			if (fetchCountries)
			{
				getOSHCountries('MATRIX_STRATEGY', ['UK'])
				.then((res) => {
					if (res) {
						setCountries(res.resultset);
						const selectedCountry = res.resultset.find((country) => country.code == props.match.params.country);
						setFilters( { ...filters, countries: [ selectedCountry ] } );
					}
				})
			}
			getOSHData('MATRIX_STRATEGY', filters)
			.then((res) => {
				// Filter the returned elements so there are no elements with empty values for all the texts
				setPageData(res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != "") )
			});
		}
		catch(error) {
			console.log('Error getting data: ', error)
		} finally {
			setIsFetching(false);
		}
	}

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22007 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		fetchData(true);
	}, [])

	useEffect(() => {
		fetchData(false);
	}, [filters] )
	
	return(
		<div>
			<AdviceSection literals={props.literals} section={["osh-steering","eu-challenges-response"]} methodologyData={{section: 'osh-steering', subsection: 'Responses of national strategies to EU challenges', indicator: 52}} />

			<section className="container">

			<SelectFilters 
				selectCountries={ countries } 
				literals={ props.literals } 
				onClickCountry={ handleCallbackCountry }
				onClickInstitution={ handleCallbackCategory }
				onSearchbarClick={ handleCallbackSearch }
				selectedFilters={ filters }
				filterCategory={ 'challenges' }
			/>

			<div className="selected--tags-wrapper">
				{ filters && (
					<div>
						{ filters.countries.map((country) => (
							<span key={country.code} className="selected-tag" onClick={ onSelectCountryTag(country.code) }>{country.code == 'EU28' ? '' : `(${country.code})`} {country.name}</span>
						))}
						{ filters.checks.map((category) => {
							if (category.check) {
								return <span key={category.id} className="selected-tag" onClick={ onSelectInstitutionTag(category.id) } >{ props.literals[`L${category.literal}`] }</span>
							}
						})}
					</div>
				)}
			</div>

			<div className="container">
				{/** Cards Component */}
				<div className="matrix--elements--wrapper">
					{ pageOfItems.length > 0 ? (
						pageOfItems.map((data, index) => {
							const position = pageData.findIndex((pageData) => pageData == data);
							const id = `${index}-${data.country.code}-${position}`
							return <Cards 
										key={ id } 
										idCard={ id }
										countryData={ data } 
										literals={ props.literals } 
										cardType={ 'challenges' } 
									/>
						})
					) : (<span>{ props.literals.L20706 }</span>)}
				</div>

				{/* PAGINATION */}
				<Pagination items={ pageData } onChangePage={ onChangePage } />
			</div>

			</section>

			<Methodology literals={ props.literals } section={'Responses of national strategies to EU challenges'} />
		</div>
	)
}
EUChallengesResponse.displayName = 'EUChallengesResponse';
export default EUChallengesResponse;